import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { catalogueEditAction, catalogueSearchAction } from './actions/CatalogueActions';
import CatalogueForm from './CatalogueForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.catalogueManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.catalogueSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.catalogueManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="master.catalogue_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<CatalogueForm />}
            />
        ),
    },
    {
        link: RoutingUtil.catalogueSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.catalogue_manager.search"
                editScope="master.catalogue_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="CatalogueReducer"
                dataPath="search"
                editAction={catalogueEditAction}
                redirectUrlOnEdit={RoutingUtil.catalogueManagerUrl()}
                action={catalogueSearchAction}
                columns={{
                    catalogueName: {
                        display: 'Catalogue Name',
                    },
                    companyName: {
                        display: 'Company Name',
                        path: 'companyId.companyName',
                    },
                    productType: {
                        display: 'Product Type',
                        path: 'productId.productName',
                    },
                    meta: [
                        {
                            display: 'C.C',
                            path: 'meta.cubicCapacity',
                        },
                        {
                            display: 'Vehicle Status',
                            path: 'meta.vehicleStatus',
                        },
                        {
                            display: 'Interest Rate',
                            path: 'meta.vehicleInsuranceInterestRate',
                        },
                    ],
                    companyCommissionId: {
                        display: 'Company Commission Slab',
                        path: 'companyCommissionId.commissionName',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const CatalogueContainer = () => (
    <CrudLayoutContainer
        title="Catalogue Manager"
        tabs={tabs}
        routes={routes}
    />
);

CatalogueContainer.propTypes = {
};

export default CatalogueContainer;
